import Api from './Api'

class Notification extends Api {
  constructor(id) {
    super()

    this.id = id

    this.markAsRead = this.markAsRead.bind(this)
    this.markAsUnread = this.markAsUnread.bind(this)
    this.markAllAsRead = this.markAllAsRead.bind(this)
    this.destroy = this.destroy.bind(this)
  }

  index(filter = 'unread', page = 1, perPage = 10) {
    const params = new URLSearchParams()
    if (filter === 'all') params.append('filter', 'all')
    params.append('page', page)
    params.append('per_page', perPage)
    const url = `${this.url}.json?${params.toString()}`
    return this.request(url, 'GET', null, false)
  }

  markAsRead() {
    return this.request(`${this.url}/${this.id}/mark_as_read`, 'PATCH')
  }

  markAsUnread() {
    return this.request(`${this.url}/${this.id}/mark_as_unread`, 'PATCH')
  }

  markAllAsRead() {
    return this.request(`${this.url}/mark_all_as_read`, 'PATCH')
  }

  get url() {
    return '/notifications'
  }
}

export default Notification
